import apiClient from "@/shared/services/apiClient";
import type { TaskColumn } from "@/features/tasks/types/task";

export interface CreateColumnPayload {
  label: string;
  color: string;
  col_order: number;
}

/** ownerType defaults to 'user' (personal board). For team boards pass 'team' + teamId. */
export async function getColumns(
  ownerType: "user" | "team" = "user",
  ownerId?: string,
): Promise<TaskColumn[]> {
  const params: Record<string, string> = { owner_type: ownerType };
  if (ownerType === "team" && ownerId) params.owner_id = ownerId;
  const { data } = await apiClient.get("/tasks/columns", { params });
  return data;
}

export async function createColumn(
  payload: CreateColumnPayload,
  ownerType: "user" | "team" = "user",
  ownerId?: string,
): Promise<TaskColumn> {
  const params: Record<string, string> = { owner_type: ownerType };
  if (ownerType === "team" && ownerId) params.owner_id = ownerId;
  const { data } = await apiClient.post("/tasks/columns", payload, { params });
  return data;
}

export async function updateColumn(
  id: string,
  payload: Partial<CreateColumnPayload>,
  ownerType: "user" | "team" = "user",
  ownerId?: string,
): Promise<TaskColumn> {
  const params: Record<string, string> = { owner_type: ownerType };
  if (ownerType === "team" && ownerId) params.owner_id = ownerId;
  const { data } = await apiClient.patch(`/tasks/columns/${id}`, payload, { params });
  return data;
}

export async function reorderColumns(
  ids: string[],
  ownerType: "user" | "team" = "user",
  ownerId?: string,
): Promise<void> {
  const params: Record<string, string> = { owner_type: ownerType };
  if (ownerType === "team" && ownerId) params.owner_id = ownerId;
  await apiClient.patch("/tasks/columns/reorder", { ids }, { params });
}

export async function deleteColumn(
  id: string,
  ownerType: "user" | "team" = "user",
  ownerId?: string,
): Promise<void> {
  const params: Record<string, string> = { owner_type: ownerType };
  if (ownerType === "team" && ownerId) params.owner_id = ownerId;
  await apiClient.delete(`/tasks/columns/${id}`, { params });
}
